export const ROUTE_NAMES = {
  CREATE_NEW_ASSISTANCE_ANKETA: 'create-new-assistance-anketa',
  CREATE_NEW_ASSISTANCE_INDEX: 'create-new-assistance-index',
  CREATE_NEW_CALCULATOR_INDEX: 'create-new-calculator-index',
  CREATE_NEW_INDEX: 'create-new-index',
  CREATE_NEW_INSURANCE_ANKETA: 'create-new-insurance-anketa',
  CREATE_NEW_INSURANCE_INDEX: 'create-new-insurance-index',
  CREATE_NEW_OSAGO_INDEX: 'create-new-osago-index',
  CREATE_NEW_SERVICE: 'create-new-service',
  EDIT_ASSISTANCE_ANKETA: 'edit-assistance-anketa',
  EDIT_ASSISTANCE_INDEX: 'edit-assistance-index',
  EDIT_CALCULATOR_INDEX: 'edit-calculator-index',
  EDIT_CREDIT_ANKETA: 'edit-credit-anketa',
  EDIT_FINAL_PARAMS: 'edit-final-params',
  EDIT_HOME: 'edit-home',
  EDIT_INDEX: 'edit-index',
  EDIT_INSURANCE_ANKETA: 'edit-insurance-anketa',
  EDIT_INSURANCE_INDEX: 'edit-insurance-index',
  EDIT_LOAN_ISSUE_INDEX: 'edit-loan-issue-index',
};

export const BASE_URL = '/worksheet';
export const CREATE_NEW_BASE_URL = `${BASE_URL}/create-new`;
export const EDIT_BASE_URL = `${BASE_URL}/:id(\\d+)`;

const ROUTES = {
  [ROUTE_NAMES.CREATE_NEW_ASSISTANCE_ANKETA]: { path: `${CREATE_NEW_BASE_URL}/assistance/anketa` },
  [ROUTE_NAMES.CREATE_NEW_ASSISTANCE_INDEX]: { path: `${CREATE_NEW_BASE_URL}/assistance` },
  [ROUTE_NAMES.CREATE_NEW_CALCULATOR_INDEX]: { path: `${CREATE_NEW_BASE_URL}/calculator` },
  [ROUTE_NAMES.CREATE_NEW_INDEX]: { path: CREATE_NEW_BASE_URL },
  [ROUTE_NAMES.CREATE_NEW_INSURANCE_ANKETA]: { path: `${CREATE_NEW_BASE_URL}/insurance/anketa` },
  [ROUTE_NAMES.CREATE_NEW_INSURANCE_INDEX]: { path: `${CREATE_NEW_BASE_URL}/insurance` },
  [ROUTE_NAMES.CREATE_NEW_OSAGO_INDEX]: { path: `${CREATE_NEW_BASE_URL}/osago` },
  [ROUTE_NAMES.CREATE_NEW_SERVICE]: { path: `${CREATE_NEW_BASE_URL}/service` },
  [ROUTE_NAMES.EDIT_ASSISTANCE_ANKETA]: { path: `${EDIT_BASE_URL}/assistance/anketa` },
  [ROUTE_NAMES.EDIT_ASSISTANCE_INDEX]: { path: `${EDIT_BASE_URL}/assistance` },
  [ROUTE_NAMES.EDIT_CALCULATOR_INDEX]: { path: `${EDIT_BASE_URL}/calculator` },
  [ROUTE_NAMES.EDIT_CREDIT_ANKETA]: { path: `${EDIT_BASE_URL}/credit/anketa` },
  [ROUTE_NAMES.EDIT_FINAL_PARAMS]: { path: `${EDIT_BASE_URL}/final-params` },
  [ROUTE_NAMES.EDIT_HOME]: { path: `${EDIT_BASE_URL}/home` },
  [ROUTE_NAMES.EDIT_INDEX]: { path: EDIT_BASE_URL },
  [ROUTE_NAMES.EDIT_INSURANCE_ANKETA]: { path: `${EDIT_BASE_URL}/insurance/anketa` },
  [ROUTE_NAMES.EDIT_INSURANCE_INDEX]: { path: `${EDIT_BASE_URL}/insurance` },
  [ROUTE_NAMES.EDIT_LOAN_ISSUE_INDEX]: { path: `${EDIT_BASE_URL}/loan-issue` },
};

Object.keys(ROUTES).forEach((key) => {
  ROUTES[key].exact ??= true;
});

export { ROUTES };
